<ng-container *transloco="let t">
  <IChangePasswordForm
    (onFormChange)="updatePassword($event)"
    (onCancel)="closeRef()"
    [loading]="submitLoading()"
    [error]="error()"
  />
</ng-container>
